<template>
  <RevToast :to />
</template>

<script setup lang="ts">
import { RevToast } from '@ds/components/Toast'

defineProps<{ to?: string }>()
</script>
